module.exports = __webpack_public_path__ + "static/media/136853_04big.aafc54d5.jpg";